import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';

import { AuthService } from './auth.service';
import { AuthGuard } from './auth.guard';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    AuthService,
    AuthGuard,
    JwtHelperService,
  ],
})
export class AuthModule {}
